const STORM_KEYWORDS =
  /\b(storm|hail|wind|damage|insurance|hurricane|repair|rain)\b/i;

export function formatDisplayRating(rating) {
  return (Math.round(rating * 10) / 10).toFixed(1);
}

export function formatReviewMonth(createTime) {
  if (!createTime) return "";
  const date = new Date(createTime);
  return date.toLocaleDateString("en-US", { month: "long", year: "numeric" });
}

export function normalizeGmbReview(locationReview) {
  const review = locationReview.review || locationReview;

  const displayName = review.reviewer?.displayName || "Customer";

  return {
    id: review.reviewId,
    author: displayName,
    firstName: displayName.split(" ")[0],
    comment: review.comment || "",
    starRating: review.starRating,
    createTime: review.createTime,
    profilePhotoUrl: review.reviewer?.profilePhotoUrl,
    monthLabel: formatReviewMonth(review.createTime),
  };
}

export function pickFeaturedReviews(reviews, count = 3) {
  if (!reviews.length) return [];

  const stormReviews = reviews.filter((review) =>
    STORM_KEYWORDS.test(review.comment)
  );

  if (stormReviews.length >= count) {
    return stormReviews.slice(0, count);
  }

  const combined = [...stormReviews];
  for (const review of reviews) {
    if (!combined.find((item) => item.id === review.id)) {
      combined.push(review);
    }
    if (combined.length >= count) break;
  }

  return combined.slice(0, count);
}
